import * as React from 'react';
import { Link } from 'react-router-dom';

export interface Kpi {
  readonly label: string;
  readonly value: React.ReactNode;
  readonly sub: React.ReactNode;
  /** An in-app path the tile opens. */
  readonly href?: string;
  readonly warn?: boolean;
}

/** The prototype's `kpis()`: four totals tiles in a row (two on a phone). */
export function Kpis({ items }: { readonly items: ReadonlyArray<Kpi> }): React.ReactElement {
  return (
    <section className="kpis" aria-label="Totals">
      {items.map((item) => {
        const content = (
          <>
            <span className="kpi-label">{item.label}</span>
            <span className="kpi-value num" style={item.warn ? { color: 'var(--warn-ink)' } : undefined}>
              {item.value}
            </span>
            <span className="kpi-sub">{item.sub}</span>
          </>
        );
        return item.href !== undefined ? (
          <Link key={item.label} to={item.href} className="card kpi" style={{ textDecoration: 'none', color: 'var(--ink)' }}>
            {content}
          </Link>
        ) : (
          <div key={item.label} className="card kpi">
            {content}
          </div>
        );
      })}
    </section>
  );
}
